import { render, staticRenderFns } from "./ContactFrom.vue?vue&type=template&id=32a4a91d"
import script from "./ContactFrom.vue?vue&type=script&lang=js"
export * from "./ContactFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports